import {
  useLayoutEffect,
  useState
} from 'react'
import { Stack } from '@chakra-ui/react'
import { CreateComment } from 'components/UserSection/ProfileBlog/Comments/CreateComment'
import { CommentsForPost } from 'components/UserSection/ProfileBlog/Comments/CommentsForPost'
import { SUCCEEDED } from 'utils/constants'
import { COLORS } from 'utils/styles'

export const Comments = ({
  blogParent,
  comments,
  commentsOption,
  getCommentsStatus,
  postCommentsStatus,
  putCommentsStatus,
  deleteCommentsStatus,
  selectedUser
}) => {
  const [editCommentData, setEditCommentData] = useState({})
  const [stickyHeaderHeight, setStickyHeaderHeight] = useState(
    () => document.querySelector('#stickyHeader' + blogParent[0]?.id)?.offsetHeight ?? 0
  )
  const parentData = blogParent[blogParent.length - 1]

  useLayoutEffect(() => {
    const el = document.querySelector('#stickyHeader' + blogParent[0]?.id)
    if (!el) return () => {}

    setStickyHeaderHeight(el.offsetHeight)

    const observer = new ResizeObserver(() => setStickyHeaderHeight(el.offsetHeight))
    observer.observe(el)

    return () => observer.disconnect()
  }, [blogParent])

  const handleMinHeight = () => {
    const wholeParent = document.querySelector('#BLOGS-drawer-body')
    if (!blogParent.length) {
      return '100svh'
    }

    if (wholeParent) {
      return wholeParent.offsetHeight - stickyHeaderHeight - (blogParent?.length > 1 ? 1 : 0.5)
    }

    return '100svh'
  }

  return (
    <Stack
      key={parentData?.comment_id ?? parentData?.id}
      direction="column"
      margin="0"
      padding="10px 5px"
      minHeight={handleMinHeight()}
      background={COLORS.darkGray}
    >
      {
        getCommentsStatus === SUCCEEDED || comments.length
          ? (
            <CreateComment
              selectedUser={selectedUser}
              blogParent={blogParent}
              getCommentsStatus={getCommentsStatus}
              type={commentsOption.type}
              postCommentsStatus={postCommentsStatus}
              putCommentsStatus={putCommentsStatus}
              deleteCommentsStatus={deleteCommentsStatus}
              editCommentData={editCommentData}
              setEditCommentData={setEditCommentData}
            />
          ) : ''
      }

      <CommentsForPost
        blogParent={blogParent}
        comments={comments}
        commentsOption={commentsOption}
        getCommentsStatus={getCommentsStatus}
        selectedUser={selectedUser}
        setEditCommentData={setEditCommentData}
      />
    </Stack>
  )
}
